(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-the-set-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('same-vendor-products')) {
    customElements.define('same-vendor-products', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.loadProducts();
      }

      async loadProducts() {
        const track = this.querySelector('.section-vendor-products');
        const status = this.querySelector('[data-vendor-status]');
        const limit = Number(this.dataset.limit) || 10;
        const seen = new Set([this.dataset.productId]);
        let count = 0;
        let url = new URL(this.dataset.url, window.location.origin);
          url.searchParams.set('q', this.dataset.vendor);
          url.searchParams.set('section_id', 'vendor-products-source');
          const currentParams = new URL(window.location.href).searchParams;
          const prepareUrl = (target) => {
            target.searchParams.set('q', this.dataset.vendor);
            target.searchParams.set('section_id', 'vendor-products-source');
            for (const name of ['preview_theme_id', '_fd', 'pb']) {
              if (currentParams.has(name)) target.searchParams.set(name, currentParams.get(name));
            }
            return target;
          };
          url = prepareUrl(url);
          try {
            if (!this.dataset.vendor.trim()) {
              this.showFallback();
              return;
            }
            while (url && count < limit) {
              const response = await fetch(url, { credentials: 'same-origin' });
              if (!response.ok) throw new Error(`HTTP ${response.status}: ${url.pathname}`);
              const responseText = await response.text();
              if (/Liquid (?:error|syntax error)/i.test(responseText)) {
                throw new Error('Errore Liquid nella sezione vendor-products-source o nello snippet card-product.');
              }
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const source = html.querySelector('[data-vendor-products-source]');
              if (!source) throw new Error('Risposta senza la sezione vendor-products-source (file mancante, tema diverso o redirect).');
            for (const card of source.querySelectorAll('[data-vendor-product-id]')) {
              const id = card.dataset.vendorProductId;
              if (card.dataset.vendor !== this.dataset.vendor || seen.has(id)) continue;
              seen.add(id);
              track.appendChild(document.importNode(card, true));
              if (++count >= limit) break;
            }
            const next = source.dataset.nextUrl;
            url = next ? new URL(next, window.location.origin) : null;
              if (url) url = prepareUrl(url);
          }
          status.hidden = true;
          if (count === 0) {
            this.showFallback();
          }
        } catch (error) {
            status.replaceChildren();
            status.hidden = true;
            if (count === 0) this.showFallback();
            if (window.Shopify && window.Shopify.designMode) {
              status.hidden = false;
            }
            console.error('[same-vendor-products]', error.message, url ? url.toString() : '', error);
        } finally {
          this.setAttribute('aria-busy', 'false');
        }
      }

      showFallback() {
        const track = this.querySelector('.section-vendor-products');
        const template = this.querySelector('[data-vendor-fallback]');
        if (track && template) {
          track.replaceWith(template.content.cloneNode(true));
        }
        this.querySelector('[data-vendor-status]').hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
